import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { ServicePayload } from '@nx-frontend/shared/types';
import { MandateProps } from '@nx-frontend/shared/types/mandate-props';

interface UpdateAttachmentAnnotationPayload extends MandateProps<ServicePayload, 'userId'> {
  workspaceId: string;
  attachmentId: string;
  textDetailed: unknown;
}

export async function updateAttachmentAnnotation({
  host,
  workspaceId,
  userId,
  attachmentId,
  textDetailed,
}: UpdateAttachmentAnnotationPayload): Promise<Record<string, unknown>> {
  const response = await axiosClient.post(
    `${assertServiceHost(host)}/v1/workspaces/${workspaceId}/annotations/${attachmentId}`,
    {
      textDetailed,
    },
    {
      userId,
    }
  );
  return response.data;
}
